'use client'

import { NotificationBell as Bell } from '@mentora/feature-components'
import { getNotificationBadgeCountAction } from '@/app/(app)/notifications/actions'
import { authClient } from '@/lib/auth-client'

// The bell lives in @mentora/feature-components (chrome); this binds it to the
// storefront's session and badge-count action.
export function NotificationBell() {
  const { data: session, isPending } = authClient.useSession()
  return <Bell signedIn={!isPending && Boolean(session?.user)} getBadgeCount={getNotificationBadgeCountAction} />
}
